import { useEffect, useState, useMemo } from 'react'
import {
  getAllNotesIdAsync,
  getNoteByIdAsync,
  clearNoteById,
  resetNotesListAndNoteById,
} from '../../../../../redux/flows/portal/lobby'
import { useAppDispatch, useAppSelector } from '../../../../../redux/store'
import { APIStatus } from '../../../../../redux/types'

const useNotes = () => {
  const dispatch = useAppDispatch()

  const currentPatient = useAppSelector((state) => state.lobbyPortal.patientDetails)
  const notesIdList = useAppSelector((state) => state.lobbyPortal.getAllNotesId)
  const notesIdListStatus = useAppSelector((state) => state.lobbyPortal.getAllNotesIdStatus)

  const noteById = useAppSelector((state) => state.lobbyPortal.noteById)
  const noteByIdStatus = useAppSelector((state) => state.lobbyPortal.noteByIdStatus)

  const [currentIndex, setCurrentIndex] = useState(0)
  const [notes, setNotes] = useState({ s: '', o: '', a: '', p: '' })

  useEffect(() => {
    if (!currentPatient?.patient?.id) return

    dispatch(clearNoteById())
    setCurrentIndex(0)

    dispatch(getAllNotesIdAsync({ patientId: currentPatient.patient.id }))
  }, [currentPatient?.patient?.id, dispatch])

  useEffect(() => {
    if (notesIdListStatus !== APIStatus.fulfilled) return
    if (!notesIdList || notesIdList.length === 0) return

    const firstNoteId = notesIdList[0]?.id
    if (firstNoteId) {
      dispatch(getNoteByIdAsync({ noteId: firstNoteId }))
    }
  }, [notesIdListStatus, notesIdList, dispatch])

  const displayedNote = useMemo(() => {
    return noteById
  }, [noteById])

  useEffect(() => {
    if (displayedNote) {
      setNotes({
        s: displayedNote.subjective ?? '',
        o: displayedNote.objective ?? '',
        a: displayedNote.assessment ?? '',
        p: displayedNote.plan ?? '',
      })
    }
  }, [displayedNote])

  const handlePrevious = () => {
    if (currentIndex < notesIdList.length - 1) {
      const newIndex = currentIndex + 1
      const id = notesIdList[newIndex]?.id
      if (id) {
        setCurrentIndex(newIndex)
        dispatch(getNoteByIdAsync({ noteId: id }))
      }
    }
  }

  const handleNext = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1
      const id = notesIdList[newIndex]?.id
      if (id) {
        setCurrentIndex(newIndex)
        dispatch(getNoteByIdAsync({ noteId: id }))
      }
    }
  }

  const canGoPrevious = currentIndex < notesIdList.length - 1
  const canGoNext = currentIndex > 0

  const isLoading = notesIdListStatus === APIStatus.pending || noteByIdStatus === APIStatus.pending

  return {
    notes,
    displayedNote,
    handlePrevious,
    handleNext,
    canGoPrevious,
    canGoNext,
    isLoading,
    currentIndex,
    totalNotes: notesIdList.length,
  }
}

export default useNotes
